module.exports = __webpack_public_path__ + "static/media/message_icon.478a8dda.svg";